import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const PageContainer = styled.div`
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  padding: 20px;
  padding-bottom: 0;
`;

export const CategoriesStyled = styled.div`
  height: 100%;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
`;

export const NameContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  margin-bottom: 10px;
  h3 {
    margin: 0;
  }
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  p {
    margin: 0;
    margin-bottom: 5px;
  }
`;

export const Input = styled.input`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  border: none;
  word-break: break-word;
  min-width: 175px;
  width: 500px;

  &::placeholder {
    color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  }

  &:focus-visible {
    outline: none;
  }
`;

export const NewCategoryOptions = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  row-gap: 20px;
  p,
  h4 {
    margin: 0;
  }
`;

export const EmptyStateWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  column-gap: 20px;
  padding-bottom: 20px;
  min-height: calc(100vh - 80px);
`;

export const CategoryModalParagraph = styled.p`
  margin-bottom: 20px;
`;

export const CategoryModalList = styled.ul`
  padding-left: 20px;
  margin-bottom: 0px;
`;

export const CategoryListBody = styled.div`
  margin-top: 20px;
`;

export const OrderInfoContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
`;

export const OrderInfoSubtitle = styled.h3`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  margin: 0;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const OrderInfo = styled(StyledIcon)`
  cursor: pointer;
`;

export const TabsContainer = styled.div`
  display: flex;
  margin-top: 32px;
  flex-direction: column;
`;
